import { POOL_STATUS } from 'src/DTO/PoolStatus.enum';
import { Labels } from 'src/hooks/useLabels.types';

export const getStatusLabel = (value: POOL_STATUS, labels: Labels<POOL_STATUS>): string => {
  return labels[value] || value;
};
